import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

type TTileContentProps = {
    fullWidts?: boolean;
    className?: string;
};

const TileContent: FC<PropsWithChildren<TTileContentProps>> = ({ className, children }) => {
    return (
        <div
            className={classNames(
                'tw-grid tw-gap-5 lg:tw-grid-cols-3 md:tw-grid-cols-2 tw-px-4',
                className,
            )}
        >
            {children}
        </div>
    );
};

export default TileContent;
